import {Databases, Query} from "appwrite";
import {client, database_id} from "../lib/appwrite";
import {v4 as uuidv4} from "uuid";
import {OfficeItem} from "../types/office";

const OFFICES_COLLECTION_ID = "67928ad4002ac6065e88"

const databases = new Databases(client);

export const officeService = {

  async create(data: OfficeItem): Promise<OfficeItem> {
    try {
      const office = await databases.createDocument(
        database_id,
        OFFICES_COLLECTION_ID,
        uuidv4(),
        data
      ) as unknown as OfficeItem;

      return office;
    } catch (error) {
      console.error('Помилка створення кабінету:', error);
      throw error;
    }
  },

  async update(data: OfficeItem): Promise<OfficeItem> {
    try {
      const id = data.$id as string
      const {$id, ...correctData} = data
      const response = await databases.updateDocument(
        database_id,
        OFFICES_COLLECTION_ID,
        id,
        correctData
      )
      const updatedOfficeData = response as unknown as OfficeItem
      return updatedOfficeData;
    } catch (error) {
      throw error;
    }
  },

  async list(queries: string[] = [], limit: number = 25): Promise<OfficeItem[]> {
    try {
      const response = await databases.listDocuments(
        database_id,
        OFFICES_COLLECTION_ID,
        [
          Query.limit(limit),
          ...queries
        ]
      );
      const offices = response.documents.map(doc => doc as unknown as OfficeItem);
      return offices;
    } catch (error) {
      console.error('Error listing offices:', error);
      throw error;
    }
  },

  async delete(id: string): Promise<void> {
    try {
      await databases.deleteDocument(
        database_id,
        OFFICES_COLLECTION_ID,
        id
      );
    } catch (error) {
      console.error('Error deleting office:', error);
      throw error;
    }
  },

  async getOfficeItem(id: string): Promise<OfficeItem> {
    try {
      const current = await databases.getDocument(
        database_id,
        OFFICES_COLLECTION_ID,
        id
      ) as unknown as OfficeItem;

      return current;
    } catch (error) {
      console.error('Помилка кабінету тест:', error);
      throw error;
    }
  }
}